import React from 'react';
import { Box, Typography, Dialog, IconButton, Grid, Divider } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { makeStyles } from '@mui/styles';
import classes from './bulk.module.scss';

const useStyles = makeStyles(() => ({
  paper: {
    borderRadius: '1rem',
    direction: 'rtl',
  },
}));

interface Errors {
  InvalidName: any[];
  InvalidLastName: any[];
  InvalidMobileNumber: { mobileNumber: string }[];
  AlreadyAdded: any[];
  assignedToAnotherOrganization: any[];
}

interface ErrDataProps {
  UsersAdded: number;
  UsersNotAdded: number;
  errors: Errors;
}
interface BulkCreateErrorProps {
  openBulkCreateError: boolean;
  closeDialog: () => void;
  errData: ErrDataProps;
}

const BulkCreateError: React.FC<BulkCreateErrorProps> = (props) => {
  const { openBulkCreateError, closeDialog, errData } = props;
  const styles = useStyles();

  const { UsersAdded = 0, UsersNotAdded = 0, errors } = errData || {};
  const {
    InvalidMobileNumber = [],
    InvalidName = [],
    InvalidLastName = [],
    AlreadyAdded = [],
    assignedToAnotherOrganization = [],
  } = errors || {};

  return (
    <Dialog
      onClose={closeDialog}
      open={openBulkCreateError}
      maxWidth='lg'
      classes={{ paper: styles.paper }}
    >
      <Box className={classes.mainDialog}>
        <Box className={classes.header}>
          <Typography color='text.main' fontWeight='bold'>
            نتیجه اضافه کردن کاربران به صورت دسته ایی
          </Typography>
          <IconButton onClick={closeDialog}>
            <CloseRoundedIcon color='action' />
          </IconButton>
        </Box>

        <Box className={classes.rowItem} mt={1}>
          <Typography color='success.dark'>تعداد موفق:</Typography>
          <Typography color='success.dark' fontSize='small' fontWeight='bold'>
            {UsersAdded}
          </Typography>
        </Box>

        <Box className={classes.rowItem} mb={1}>
          <Typography color='error.main'> تعداد ناموفق:</Typography>
          <Typography color='error.main' fontSize='small' fontWeight='bold'>
            {UsersNotAdded}
          </Typography>
        </Box>

        <Divider sx={{ margin: '0.25rem 0' }} />

        <Typography color='text.main' fontWeight='bold'>
          لیست خطا‌ها:
        </Typography>

        <Grid container>
          <Grid item lg={2} p={1}>
            <Box className={classes.errorContainer}>
              <Typography color='text.light' fontWeight='bold'>
                قبلا اضافه شده
              </Typography>
              {AlreadyAdded.length === 0 ? (
                <Typography mt={1} color='text.main' fontSize='small'>
                  -
                </Typography>
              ) : (
                AlreadyAdded.map((i: any, index: number) => (
                  <Typography
                    key={`${i.mobileNumber}${index}`}
                    mt={1}
                    color='text.main'
                    fontSize='small'
                  >
                    {i.name + ' ' + i.lastname}
                    {` - سطر(${i.row})`}
                  </Typography>
                ))
              )}
            </Box>
          </Grid>
          <Grid item lg={2} p={1}>
            <Box className={classes.errorContainer}>
              <Typography color='text.light' fontWeight='bold'>
                به یک سازمان دیگه اضافه شده
              </Typography>
              {assignedToAnotherOrganization.length === 0 ? (
                <Typography mt={1} color='text.main' fontSize='small'>
                  -
                </Typography>
              ) : (
                assignedToAnotherOrganization.map((i: any, index: number) => (
                  <Typography
                    key={`${i.mobileNumber}${index}`}
                    mt={1}
                    color='text.main'
                    fontSize='small'
                  >
                    {i.mobileNumber}
                    {`سطر(${i.row})`}
                  </Typography>
                ))
              )}
            </Box>
          </Grid>
          <Grid item lg={2} p={1}>
            <Box className={classes.errorContainer}>
              <Typography color='text.light' fontWeight='bold'>
                نام اشتباه
              </Typography>
              {InvalidName.length === 0 ? (
                <Typography mt={1} color='text.main' fontSize='small'>
                  -
                </Typography>
              ) : (
                InvalidName.map((i: any, index: number) => (
                  <Typography
                    key={`${i.mobileNumber}${index}`}
                    mt={1}
                    color='text.main'
                    fontSize='small'
                  >
                    {i.name}
                    {` - سطر(${i.row})`}
                  </Typography>
                ))
              )}
            </Box>
          </Grid>
          <Grid item lg={2} p={1}>
            <Box className={classes.errorContainer}>
              <Typography color='text.light' fontWeight='bold'>
                نام خانوادگی اشتباه
              </Typography>
              {InvalidLastName.length === 0 ? (
                <Typography mt={1} color='text.main' fontSize='small'>
                  -
                </Typography>
              ) : (
                InvalidLastName.map((i: any, index: number) => (
                  <Typography
                    key={`${i.mobileNumber}${index}`}
                    mt={1}
                    color='text.main'
                    fontSize='small'
                  >
                    {i.lastname}
                    {` - سطر(${i.row})`}
                  </Typography>
                ))
              )}
            </Box>
          </Grid>
          <Grid item lg={2} p={1}>
            <Box className={classes.errorContainer}>
              <Typography color='text.light' fontWeight='bold'>
                شماره همراه اشتباه
              </Typography>

              {InvalidMobileNumber.length === 0 ? (
                <Typography mt={1} color='text.main' fontSize='small'>
                  -
                </Typography>
              ) : (
                InvalidMobileNumber.map((i: any, index: number) => (
                  <Typography
                    key={`${i.mobileNumber}${index}`}
                    mt={1}
                    color='text.main'
                    fontSize='small'
                  >
                    {i.mobileNumber}
                    {` - سطر(${i.row})`}
                  </Typography>
                ))
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};

export default BulkCreateError;
